//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListSkeleton from "@/components/Skeletons/ListSkeleton";
import Roles from '@/api/promotores/roles.api'

export default {
  components: { ListSkeleton },

  props: {
    rolId: Number
  },

  data() {
    return {
      loading: false,
      roles: [],
      rolId_: this.rolId
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
      this.loadRoles()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    async loadRoles() {
      try {
        this.loading = true
        this.roles = await Roles.all({ order: 'nombre:asc', columns: 'id,nombre,avatar'})
      } finally {
        this.loading = false
      }
    },
    submit() {
      const rol = this.roles.find((rol) => rol.id == this.rolId_)

      this.$emit("ok", rol);
    }
  }
}
